import { AuthService } from '../services/AuthService';
import { CustomError, type IGenericResponseRoot } from '../utils/getErrorData';
import { api } from '../utils/api';
import {
  IGetReviewFeedbackParams,
  IReviewFeedbackItem,
  IReviewFeedbackListResponse
} from '@/types/IReviewFeedback';
import {
  USE_MOCK_PRODUCT_REVIEWS,
  getMockProductReviewsResponse
} from '@/mocks/productReviews/productReviewsMocks';

export const getReviews = async (
  params: IGetReviewFeedbackParams
): Promise<IGenericResponseRoot<IReviewFeedbackListResponse>> => {
  if (USE_MOCK_PRODUCT_REVIEWS && params.product !== undefined) {
    return {
      response: getMockProductReviewsResponse(params),
      meta: { error: null, datetime: Date.now() }
    };
  }

  try {
    const headers: Record<string, string> = {};

    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      await AuthService.checkUser();
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.get<
      IGenericResponseRoot<IReviewFeedbackListResponse>
    >(`${import.meta.env.VITE_API_URL}/api/admin/product-feedback/list`, {
      headers,
      params
    });

    if (response.status === 500) {
      throw new CustomError(
        'При получении отзывов произошла необработанная ошибка'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('Ошибка. Отзывов не было найдено.');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const updateReviewStatus = async (
  feedbackId: string,
  published: boolean
): Promise<IGenericResponseRoot<IReviewFeedbackItem>> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      await AuthService.checkUser();
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.put<IGenericResponseRoot<IReviewFeedbackItem>>(
      `${import.meta.env.VITE_API_URL}/api/admin/product-feedback/${feedbackId}`,
      null,
      {
        headers,
        params: { published }
      }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при обновлении статуса отзыва'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При обновлении статуса отзыва произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};
